import {
  lesson4Assignment3
} from './assignments'
import { highlightCoordinates } from '../commonActivities'

let lessonConfig = [
  {
    id: 0,
    previous: null,
    next: 2,
    video: {
      src: 'img/videos/lesson_4/1.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 1
    }
  },
  {
    id: 1,
    previous: 0,
    next: 2,
    audio: { src: 'img/audio/lesson_4/1.mp3', start: true, controls: false },
    chessboard: {
      board: highlightCoordinates({
        showIndicators: { allSides: true },
        position: { d4: 'wN' },
        coordinates: ['.square-b3', '.square-b5', '.square-c2', '.square-c6', '.square-e2', '.square-e6', '.square-f3', '.square-f5'],
        coordinateClass: 'filled-square',
        reminder: true,
        next: 2
      })
    },
    directions: {
      timeout: 13000,
      data: `<b>DIRECTIONS:</b> <br/>Click on the eight <br/>squares the Knight <br/>could move to from <br/>his d4 square.`
    }
  },
  {
    id: 2,
    previous: 0,
    next: 4,
    video: {
      src: 'img/videos/lesson_4/2.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 3,
    }
  },
  {
    id: 3,
    previous: 2,
    next: 4,
    audio: { src: 'img/audio/lesson_4/2.mp3', start: true, controls: false },
    directions: {
      data: `<b>DIRECTIONS:</b> <br/>Click on the 3 pieces <br/>the White Knight <br/>could capture from <br/>the d4 square.`,
      timeout: 9500
    },
    chessboard: {
      board: highlightCoordinates({
        showIndicators: { allSides: true },
        position: { b4: 'bP', c3: 'bP', c5: 'bP', c6: 'bP', d3: 'bN', d4: 'wN', e2: 'bB', f5: 'bP', f6: 'bN', g5: 'bP' },
        coordinates: ['.square-c6', '.square-e2', '.square-f5'],
        coordinateClass: 'filled-square',
        bubbleConfig: {
          data: 'Nice job userName!',
          position: 'left',
          styleClass: 'xs'
        },
        reminder: true,
        next: 4
      })
    }
  },
  {
    id: 4,
    previous: 2,
    next: 6,
    video: {
      src: 'img/videos/lesson_4/3.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 5,
    }
  },
  {
    id: 5,
    previous: 4,
    next: 6,
    audio: { src: 'img/audio/lesson_4/3.mp3', start: true, controls: false },
    text: {
      data: 'The pawns are frozen, only the Knight moves.',
      position: 'left',
      timeout: 10000,
      styleClass: 'md'
    },
    chessboard: {
      board: lesson4Assignment3({
        showIndicators: { allSides: true },
        position: '8/8/3PPP2/3PnP2/3PPP2/8/8/8',
        coordinateClass: '.piece-417db[data-piece=wP]',
        assignmentClass: 'custom-sparepiece',
        next: 6
      }),
      positionFen: '8/8/3PPP2/3PnP2/3PPP2/8/8/8 b - - 0 1',
    },
    directions: {
      timeout: 9000,
      data: `<b>DIRECTIONS:</b> <br/>You have nine <br/>moves, one move <br/>to jump out, <br/>and eight moves <br/>to capture <br/>all eight pawns.`
    }
  },
  {
    id: 6,
    previous: 4,
    next: 7,
    video: {
      src: 'img/videos/lesson_4/4.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 7,
    }
  },
  {
    id: 7,
    previous: 6,
    next: 8,
    audio: { src: 'img/audio/qa_bgm.mp3', start: true, loop: true },
    qa: {
      id: 0,
      question: "What is the Knight's special talent?",
      answer: [
        'He can capture two pieces in one turn',
        'He can change his color',
        'He can get promoted to a Queen',
        'He can jump over other pieces'
      ],
      rightAnswer: 'He can jump over other pieces',
      validateAnswer: { rightAnswer: 3, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 8,
    previous: 6,
    next: 9,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 1,
      question: "What is the Knight's symbol?",
      answer: [
        'K',
        'N',
        'T',
        'B'
      ],
      rightAnswer: 'N',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 9,
    previous: 6,
    next: 10,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 2,
      question: 'Which piece does the Knight capture?',
      answer: [
        'The one he lands on',
        'The one he jumps over',
        'The one to his left',
        'The one to his right'
      ],
      rightAnswer: 'The one he lands on',
      validateAnswer: { rightAnswer: 0, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 10,
    previous: 6,
    next: 11,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 3,
      question: "What phrase helps you remember how the Knight moves and captures?",
      answer: [
        'One, two three, eyes on me',
        'Hippity-hippity-hop',
        "Dark or light, it's alright",
        'One and done'
      ],
      rightAnswer: 'Hippity-hippity-hop',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 11,
    previous: 6,
    next: 12,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 4,
      question: 'How many points is the Knight worth?',
      answer: [
        '1',
        '2',
        '3',
        '4'
      ],
      rightAnswer: '3',
      validateAnswer: { rightAnswer: 2, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 12,
    previous: 6,
    next: 13,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 5,
      question: 'Where do the Knights stand at the start of the game?',
      answer: [
        'A and H files',
        'B and G files',
        'C and F files',
        'D and E files'
      ],
      rightAnswer: 'B and G files',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'md'
    }
  }, {
    id: 13,
    previous: 6,
    next: 14,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 6,
      question: 'How were Knights in the Middle Ages equipped for battle?',
      answer: [
        'They had a shield',
        'They had protective armor',
        'They rode horseback',
        'All of the above'
      ],
      rightAnswer: 'All of the above',
      validateAnswer: { rightAnswer: 3, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 14,
    previous: 6,
    next: 15,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 7,
      question: 'What is the shape of a Knight move?',
      answer: [
        'S',
        'U',
        'N',
        'L'
      ],
      rightAnswer: 'L',
      validateAnswer: { rightAnswer: 3, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 15,
    previous: 6,
    next: 16,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 8,
      question: 'How often does a Knight change his square color?',
      answer: [
        'Whenever he wants',
        'Every time he moves',
        'Only when he captures',
        'He never changes square color'
      ],
      rightAnswer: 'Every time he moves',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 16,
    previous: 6,
    next: 17,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 9,
      question: 'Can a Knight move backwards?',
      answer: [
        'No, he only moves straight ahead',
        'No, he only moves sideways and forward',
        'No, he only moves in a T shape across the board',
        'Yes, he can move any direction he wants in an L shape'
      ],
      rightAnswer: 'Yes, he can move any direction he wants in an L shape',
      validateAnswer: { rightAnswer: 3, userAnswer: -1 },
      styleClass: 'xl'
    }
  },
  {
    id: 17,
    previous: 6,
    next: null,
    audio: { src: null, stop: true },
    qa: {
      position: 'center',
      result: true,
      nextLesson: 'Lesson Five',
      styleClass: 'xl'
    }
  }
];

let assets = [
  '/img/background_3.png',
  '/img/background_4.png',
  '/img/background_5.png',
];

let config = {
  config: lessonConfig,
  assets: assets
};

export default config;


// WEBPACK FOOTER //
// ./src/lessons/lesson_4/index.js